import { Typography } from 'antd';
import styled from 'styled-components';

const { Title } = Typography;

/**
 * Titolo (heading 3) condiviso per le intestazioni della richiesta: titolo del
 * modulo e titoli dei riepiloghi (Frontoffice e Backoffice).
 *
 * Definisce SOLO `font-size`/`line-height` dal tema — il denominatore comune ai
 * tre usi. La spaziatura (margin/padding) resta a carico del contenitore di
 * ciascun consumer, che la imposta come serve (es. il titolo del modulo la
 * azzera, i riepiloghi tengono il margine di default di `Typography.Title`).
 */
export const SubmissionHeadingTitle = styled(Title)`
  &&& {
    font-size: ${props => props.theme.fontSizeHeading3}px;
    line-height: ${props => props.theme.lineHeightHeading3};
  }
`;
